// ── Where a register row lives ────────────────────────────────────────────
// The entity kinds (mirror of backend lib/entityTags.ts) and the deep link that
// opens one row of each. Kept apart from components/EntityTags.tsx, which
// re-exports both, so the navigation shell's search can link to a record
// without loading the tagging UI.

export type EntityKind =
  | "control" | "risk" | "asset" | "supplier" | "incident" | "exercise" | "training"
  | "document" | "ropa" | "dpia" | "breach" | "request" | "action" | "ai_system" | "task" | "bia"
  | "ms_context" | "ms_objective" | "ms_audit" | "ms_review" | "ms_competence" | "ms_aspect" | "ms_hazard" | "ms_obligation"
  | "change";

/** Where a related row lives, so the panel is a way through rather than a list of names. */
export const KIND_HREFS: Record<EntityKind, (id: string) => string | null> = {
  control:   () => null,
  risk:      (id) => `/risk-register?risk=${encodeURIComponent(id)}`,
  asset:     (id) => `/resilience/assets?asset=${encodeURIComponent(id)}`,
  supplier:  (id) => `/tprm?supplier=${encodeURIComponent(id)}`,
  incident:  (id) => `/resilience/incidents?incident=${encodeURIComponent(id)}`,
  exercise:  (id) => `/resilience/exercises?exercise=${encodeURIComponent(id)}`,
  training:  (id) => `/resilience/training?record=${encodeURIComponent(id)}`,
  document:  (id) => `/documents?document=${encodeURIComponent(id)}`,
  ropa:      (id) => `/gdpr?tab=ropa&entry=${encodeURIComponent(id)}`,
  dpia:      (id) => `/gdpr?tab=dpia&record=${encodeURIComponent(id)}`,
  breach:    (id) => `/gdpr?tab=breaches&breach=${encodeURIComponent(id)}`,
  request:   (id) => `/gdpr?tab=dsr&request=${encodeURIComponent(id)}`,
  action:    (id) => `/improvement?action=${encodeURIComponent(id)}`,
  ai_system: (id) => `/ai-systems?system=${encodeURIComponent(id)}`,
  task:      (id) => `/schedule?event=${encodeURIComponent(id)}`,
  bia:       (id) => `/resilience/bia?bia=${encodeURIComponent(id)}`,
  ms_context:    (id) => `/management-system/context?entry=${encodeURIComponent(id)}`,
  ms_objective:  (id) => `/management-system/objectives?objective=${encodeURIComponent(id)}`,
  ms_audit:      (id) => `/management-system/audits?audit=${encodeURIComponent(id)}`,
  ms_review:     (id) => `/management-system/reviews?review=${encodeURIComponent(id)}`,
  ms_competence: (id) => `/management-system/competence?requirement=${encodeURIComponent(id)}`,
  ms_aspect:     (id) => `/management-system/aspects?aspect=${encodeURIComponent(id)}`,
  ms_hazard:     (id) => `/management-system/hazards?hazard=${encodeURIComponent(id)}`,
  ms_obligation: (id) => `/management-system/obligations?obligation=${encodeURIComponent(id)}`,
  change:        (id) => `/changes?change=${encodeURIComponent(id)}`,
};
